import { render } from "./Dashboard.vue?vue&type=template&id=bf927216&scoped=true"
import script from "./Dashboard.vue?vue&type=script&lang=ts"
export * from "./Dashboard.vue?vue&type=script&lang=ts"

import "./Dashboard.vue?vue&type=style&index=0&id=bf927216&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-bf927216"

export default script